import { findIndex } from 'lodash';
import * as greciliae from '../../../fonts/greciliae.names.json';
import * as gregall from '../../../fonts/gregall.names.json';
import * as grelaon from '../../../fonts/grelaon.names.json';

const nabcAliases: { [key: string]: string } = {
  'ci~': 'cl>',
  'pe~': 'ta>',
  'vs~': 'ta>',
  'pf~': 'po>',
  'sc~': 'pe>2',
  'sa~': 'pe>2',
  'suu1': 'ta-',
  'ppu1': 'ta-',
  'pfG': 'sfM',
  'cl~': 'vi>',
  'pr~': 'vs>',
  'visu2': 'ci',
  'vi-su2': 'ci-',
  'visu3': 'ci1',
  'visu1sux1': 'ci>',
  'clSsut1': 'ciG',
  'clSsu2': 'ciG1',
  'visu1suw1': 'ciM',
  'vi-su1suw1': 'ciM-',
  'visu1sut1': 'ciS',
  'visut2': 'ciS1',
  'visu2lsc3': 'cilsc3',
  'vipp2': 'sc',
  'vi-ppt2': 'sc-',
  'vipp3': 'sc1',
  'vi>pp2': 'sc>',
  'peppt1': 'scG',
  'vippt2': 'scS',
  'ta>ppt1': 'sc~',
  'clpp2': 'sf',
  'cl-ppt2': 'sf-',
  'cl>pp2': 'sf>',
  'toppt1': 'sfG',
  'clMpp2': 'sfM1',
  'clppt2': 'sfS',
  'clpp2lsc2': 'sflsc2',
  'ciSppt1': 'vippt1su1sut1',
  'cippt1': 'vippt1su2',
  'cippt1lsc3': 'vippt1su2lsc3',
  'cippu1': 'vippu1su2',
  'cippu1lsc3': 'vippu1su2lsc3',
  'clppt1': 'toG',
  'pf!cl~': 'cl!po>',
  'pf!cl~ppt1': 'cl!po>ppt1'
};

export class Glyph {
  private readonly _name: string;
  private readonly _fontFamily: string;
  private readonly _code: number;
  private readonly _size: number;

  get name(): string {
    return this._name;
  }

  get fontFamily(): string {
    return this._fontFamily;
  }

  get code(): number {
    return this._code;
  }

  get hasError(): boolean {
    return this._code < 1;
  }

  get size(): number {
    return this._size;
  }

  constructor(name: string, fontFamily: string, size: number) {
    this._name = name;
    this._fontFamily = fontFamily;
    this._size = size;

    this._code = this.getGlyphCode();

    if (this._code < 0) {
      // console.log(`Glyph "${this._name}" not found in font "${this._fontFamily}"`);
      // throw new Error(`Glyph "${this._name}" not found in font "${this._fontFamily}"`);
    }
  }

  private getGlyphCode(): number {
    if (this._fontFamily === 'gregall' || this._fontFamily === 'grelaon') {
      let aliasName: string | null = null;

      if (Object.keys(nabcAliases).includes(this._name)) {
        aliasName = nabcAliases[this._name];
      } else {
        aliasName = this._name;
      }

      const key = aliasName.replace(/>/g, 'B').replace(/-/g, 'N').replace(/!/g, 'E').replace(/~/g, 'T');

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let code = -1;

      if (this._fontFamily === 'gregall') {
        code = (gregall as any).default[key];
      } else if (this._fontFamily === 'grelaon') {
        code = (grelaon as any).default[key];
      }

      if (!code) {
        return -1;
      }

      return code;
    } else if (this._fontFamily === 'greciliae') {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const index = findIndex((greciliae as any).default, (n) => n === this._name);

      if (index < 0) {
        return -1;
      }

      return 0xE000 + index;
    }

    return -1;
  }
}
